import("../src/javascripts/attachments-redesign");
import("../src/javascripts/navigation");
import("../src/javascripts/easy-toggle");
import("../src/javascripts/landing_splide");
import("../src/javascripts/slider_splide");
import("../src/javascripts/smooth-scroll-to-anchor");
